import { HttpService } from './http-service';
import { appSettingsModule } from '@/store/app-settings-module';
import { MailWizz } from '@/models/mailwizz/mailwizz';

export class MailWizzInstanceService extends HttpService {
    protected getMailWizzInstanceId() : number { return appSettingsModule.activeMailWizzId }
    protected getMailWizzInstance() : MailWizz { return appSettingsModule.activeMailWizz }
}
